export enum EndorsementEnum {
  T = 'T',
  H = 'H',
  P = 'P',
  N = 'N',
  X = 'X',
  TWIC = 'TWIC',
  OTHER = 'OTHER',
}
